import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { RequestStatus } from "../../utils/Enums";
import {
    deleteUser,
    getCurrentUser,
    resetDeleteUserStatus,
} from "../../store/reducers/UsersSlice";
import Breadcrumbs from "../common/Breadcrumbs";
import { LoggedInView } from "../common/LoggedInView";
import { BreadcrumbLink } from "../../models/BreadcrumbLink";

interface DeleteUserScreenProps {}

export const DeleteUserScreen: React.FC<DeleteUserScreenProps> = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const usersState = useAppSelector((state) => state.users);
    const requestStatus: RequestStatus = usersState.deleteUserStatus;

    const { id } = useParams();

    const breadcrumbLinks: BreadcrumbLink[] = [
        { text: "Kasutajad", url: "/users" },
        { text: "Kasutaja kustutamine", url: `/users/${id}/delete` },
    ];

    useEffect(() => {
        dispatch(resetDeleteUserStatus());
    }, [location]);

    const handleConfirm = () => {
        if (id) {
            dispatch(deleteUser(id));
        }
    };

    const handleCancel = () => {
        navigate(-1);
    };

    useEffect(() => {
        if (id) {
            dispatch(getCurrentUser(id));
        }
    }, [id]);

    const showSuccess = () => {
        return (
            <div className="message msg-ok">
                <div>
                    <h2>Kasutaja kustutatud</h2>
                </div>
            </div>
        );
    };

    const showConfirm = () => {
        const currentUser = usersState?.currentUser;

        return (
            <div className="message" style={{ textAlign: "center" }}>
                <div>
                    <h2>
                        Oled kindel, et soovid kasutaja{" "}
                        <em>
                            {currentUser?.firstname} {currentUser?.lastname}
                        </em>{" "}
                        kustutada?
                    </h2>
                    <p>
                        <form method="post" id="delete_form" name="delete_form">
                            <input type="hidden" name="yes" value="yes" />
                            <button type="button" onClick={handleConfirm}>
                                <span>
                                    <strong>Jah</strong>
                                </span>
                            </button>
                            <button type="button" onClick={handleCancel}>
                                Ei
                            </button>
                        </form>
                    </p>
                </div>
            </div>
        );
    };

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks} />
            {requestStatus === RequestStatus.Success && showSuccess()}
            {requestStatus !== RequestStatus.Success && showConfirm()}
        </LoggedInView>
    );
};